import { TNextStepsFields, TNextStepsFieldsCard, TNextStepsProps } from '../types/nextSteps.types';
import { StringField, TBrand } from '../../../types/types';
import { BRANDS } from '../../../constants/brandNames.contants';
import { TIconProps } from '../../@shared/icon';

export class NextStepsModel {
  private readonly fields: TNextStepsFields;
  private readonly brandName: TBrand;

  constructor(props: TNextStepsProps, brandName: TBrand) {
    this.fields = props?.fields;
    this.brandName = brandName;
  }

  getBrandValue(caseCEFallbackValue, newHollandCEFallbackValue) {
    return this.brandName === BRANDS.CASE ? caseCEFallbackValue : newHollandCEFallbackValue;
  }

  get isCaseCEBrand(): boolean {
    return this.brandName === BRANDS.CASE;
  }

  get title(): StringField {
    return this.fields?.title || { value: '' };
  }

  get titleColor(): string {
    return this.fields?.titleColor?.fields?.Key?.value?.toLowerCase() || this.getBrandValue('primary-orange', 'primary-yellow');
  }

  get ctaColor(): string {
    return this.fields?.ctaColor?.fields?.Key?.value?.toLowerCase() || this.getBrandValue('lightest-grey', 'lighter-grey');
  }

  get iconColor(): TIconProps['color'] {
    return this.getBrandValue('primary', 'black');
  }

  get cards(): TNextStepsFieldsCard[] {
    return this.fields?.items || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }
}
